// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dae35626","795":"c4806313"}[chunkId] + ".chunk.js";
};